export const POB_SENTRY_APPLICATION_KEY = "pob-web";
